export interface Trip {
  id: string;
  ship: string;
  date: string;
  glassesIssued: number;
  activeVisitors: number;
  questions: number;
  faceswapCount: number;
  reportsGenerated: number;
  status: "ongoing" | "completed" | "pending";
  batch: string;
}

export interface TripVisitor {
  id: string;
  name: string;
  deviceNo: string;
  questionCount: number;
  reportGenerated: boolean;
  reportDownloads: number;
  faceswapCount: number;
  status: "active" | "offline";
}

export const tripStats = {
  todayTrips: 3,
  totalVisitors: 384,
  totalQuestions: 2647,
  totalFaceswaps: 156,
};

export const trips: Trip[] = [
  {
    id: "1",
    ship: "长江壹号",
    date: "2026-06-01",
    glassesIssued: 142,
    activeVisitors: 138,
    questions: 987,
    faceswapCount: 52,
    reportsGenerated: 138,
    status: "ongoing",
    batch: "上午批次",
  },
  {
    id: "2",
    ship: "三峡盛世",
    date: "2026-06-01",
    glassesIssued: 156,
    activeVisitors: 149,
    questions: 1123,
    faceswapCount: 67,
    reportsGenerated: 149,
    status: "ongoing",
    batch: "下午批次",
  },
  {
    id: "3",
    ship: "葛洲坝号",
    date: "2026-06-01",
    glassesIssued: 86,
    activeVisitors: 82,
    questions: 537,
    faceswapCount: 37,
    reportsGenerated: 82,
    status: "ongoing",
    batch: "傍晚批次",
  },
  {
    id: "4",
    ship: "长江壹号",
    date: "2026-05-31",
    glassesIssued: 138,
    activeVisitors: 0,
    questions: 1256,
    faceswapCount: 48,
    reportsGenerated: 135,
    status: "completed",
    batch: "上午批次",
  },
  {
    id: "5",
    ship: "三峡盛世",
    date: "2026-05-31",
    glassesIssued: 162,
    activeVisitors: 0,
    questions: 1389,
    faceswapCount: 71,
    reportsGenerated: 158,
    status: "completed",
    batch: "下午批次",
  },
  {
    id: "6",
    ship: "葛洲坝号",
    date: "2026-05-31",
    glassesIssued: 92,
    activeVisitors: 0,
    questions: 645,
    faceswapCount: 42,
    reportsGenerated: 90,
    status: "completed",
    batch: "傍晚批次",
  },
];

export const tripVisitors: TripVisitor[] = [
  { id: "1", name: "陈明远", deviceNo: "A001", questionCount: 12, reportGenerated: true, reportDownloads: 3, faceswapCount: 2, status: "active" },
  { id: "2", name: "王建国", deviceNo: "A002", questionCount: 8, reportGenerated: true, reportDownloads: 1, faceswapCount: 1, status: "active" },
  { id: "3", name: "李婷", deviceNo: "A003", questionCount: 15, reportGenerated: true, reportDownloads: 2, faceswapCount: 3, status: "active" },
  { id: "4", name: "张伟", deviceNo: "A004", questionCount: 6, reportGenerated: true, reportDownloads: 1, faceswapCount: 1, status: "active" },
  { id: "5", name: "刘芳", deviceNo: "A005", questionCount: 9, reportGenerated: true, reportDownloads: 2, faceswapCount: 2, status: "active" },
  { id: "6", name: "赵强", deviceNo: "A007", questionCount: 4, reportGenerated: false, reportDownloads: 0, faceswapCount: 0, status: "offline" },
  { id: "7", name: "孙丽", deviceNo: "A008", questionCount: 11, reportGenerated: true, reportDownloads: 3, faceswapCount: 2, status: "active" },
  { id: "8", name: "周杰", deviceNo: "A009", questionCount: 7, reportGenerated: true, reportDownloads: 1, faceswapCount: 1, status: "active" },
  { id: "9", name: "吴敏", deviceNo: "A011", questionCount: 13, reportGenerated: true, reportDownloads: 2, faceswapCount: 2, status: "active" },
  { id: "10", name: "郑浩", deviceNo: "A012", questionCount: 5, reportGenerated: true, reportDownloads: 1, faceswapCount: 1, status: "active" },
];

export const visitorQAHistory = [
  { time: "2026-06-01 14:32:18", question: "三峡大坝多高？", answer: "三峡大坝坝高185米，正常蓄水位175米。" },
  { time: "2026-06-01 14:15:33", question: "葛洲坝什么时候建成的？", answer: "葛洲坝水利枢纽于1981年全面建成。" },
  { time: "2026-06-01 13:50:22", question: "黄牛岩怎么形成的？", answer: "黄牛岩是地质构造运动和水流侵蚀共同作用的结果。" },
  { time: "2026-06-01 13:28:45", question: "三游洞有什么历史典故？", answer: "三游洞因唐代白居易、白行简、元稹三人同游而得名。" },
  { time: "2026-06-01 12:55:10", question: "西陵峡有多长？", answer: "西陵峡是三峡中最长的峡谷，全长66公里。" },
];